import React from "react";
import EntryForm from "../components/EntryForm";

export default function SaleEntry() {
  return (
    <div>
      <p className="small-label text-gray-500 mb-4">Record gas sold to customer. You give Filled, customer gives MT. Last billed rate auto-suggested.</p>
      <EntryForm type="sale" />
    </div>
  );
}
